"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionEntryList = ShopPageSubscriptionEntryList;
const react_1 = __importStar(require("react"));
const shop_page_subscription_entry_1 = require("./shop-page-subscription-entry");
function ShopPageSubscriptionEntryList({ entries, loyaltyCount }) {
    const productsRef = (0, react_1.useRef)(null);
    const imageRef = (0, react_1.useRef)(null);
    const [calculatedCount, setCalculatedCount] = (0, react_1.useState)({ product: 6, showProduct: 6, plusProduct: 0, entries: entries.length });
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const loyaltyBoxSize = (_a = productsRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        const loyaltyProductSize = (_b = imageRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth;
        let productCount = 6;
        if (loyaltyBoxSize > 0 && loyaltyProductSize > 0 && loyaltyCount > 1) {
            productCount = Math.floor(loyaltyBoxSize / loyaltyProductSize);
        }
        let showProductCount = productCount;
        let plusProductCount = 0;
        let entriesCount = entries.length;
        if (entriesCount > productCount) {
            showProductCount = showProductCount - 1;
            plusProductCount = entriesCount - showProductCount;
        }
        setCalculatedCount({ product: productCount, entries: entriesCount, plusProduct: plusProductCount, showProduct: showProductCount });
    }, []);
    let boxResultsProductsClass = "subscription__orders-box-results-products";
    if (loyaltyCount > 1) {
        boxResultsProductsClass = "loyalties__orders-box-results-products";
    }
    return react_1.default.createElement("div", { ref: productsRef, className: boxResultsProductsClass }, entries.map((orderEntry, index) => react_1.default.createElement(shop_page_subscription_entry_1.ShopPageSubscriptionEntry, { key: `${index}-${orderEntry.entryNumber}`, orderEntry: orderEntry, index: index, calculatedCount: calculatedCount, imageRef: imageRef })));
}
